import { EventLink, ScrollReset} from "./obj"

export default function Events(){
    return (<main>
        <ScrollReset/>
        <section >
            <h2>__EVENTS</h2>
            <EventLink title = "Event Calendar" to = "calendar" local = {false}>See all our events on this google calendar.</EventLink>
        </section>
        
        <section>
            <h3>training</h3>
            <EventLink title = "Weekly Workshops" to = "workshops" >Learn about the fundamentals of competitive programming here.</EventLink>
            <EventLink title = "Contest Training" to = 'training'>Practice and hone your competitive programming skills in preparation for competitions. </EventLink>

        </section>
        <section>
            <h3>contests</h3>
            <EventLink title = "Beginner’s contest" to = "beginner">Showcase your programming skills in this competition for fledgling programmers.</EventLink>
            <EventLink title = "MCPC" to = "mcpc">Go for the gold against other coders in Monash in this Sem-2 competition. </EventLink>
            <EventLink title = "Advent of MAPS" to = "advent">Be the quickest to solve a problem, every day, for 30 days.</EventLink>
            <EventLink title = "SPPC" to = "SPPC">Compete against other universities for a chance to join ICPC.</EventLink>
        </section>
    </main>)
}